import { useBook } from '@topwrite/common';
import getFullPath from './get-full-path';

export default function useFullPath(filename: string) {

    const { config } = useBook();

    const root = config.getValue('root', '');

    return getFullPath(filename, root);
}
